import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal } from "@/components/site/motion";
import { SERVICES, IMAGES } from "@/data/content";
import Seo from "@/components/site/Seo";

export default function Servizi() {
    const { t, lang } = useLang();
    return (
        <>
            <Seo title={t.seo.services.t} description={t.seo.services.d} image={IMAGES.hvac} path="/servizi" />
            <section className="relative pt-40 pb-24 bg-cb-dark cb-grid overflow-hidden">
                <div className="absolute inset-0 opacity-20">
                    <img src={IMAGES.hvac} alt="" className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-cb-darker/80" />
                </div>
                <div className="relative max-w-7xl mx-auto px-6">
                    <Reveal className="text-cb-accent text-xs uppercase tracking-[0.3em] mb-4">02 — Servizi</Reveal>
                    <Reveal as="h1" delay={0.4} className="font-display text-5xl md:text-6xl font-bold tracking-tighter text-white">{t.servicesPage.title}</Reveal>
                    <Reveal delay={0.8} className="mt-6 max-w-2xl text-slate-300 text-lg">{t.servicesPage.sub}</Reveal>
                </div>
            </section>

            <section className="py-20 bg-white">
                <div className="max-w-7xl mx-auto px-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200">
                    {SERVICES.map((s, i) => {
                        const Icon = s.icon;
                        return (
                            <Reveal key={s.slug} delay={i * 0.4}>
                                <Link to={`/servizi/${s.slug}`} data-testid={`services-list-${s.slug}`}
                                    className="group block h-full bg-white p-10 hover:bg-cb-dark transition-colors duration-500">
                                    <Icon size={44} strokeWidth={1.2} className="text-cb-accent" />
                                    <h3 className="mt-8 font-display text-2xl font-semibold text-cb-dark group-hover:text-white transition-colors">{s[lang].name}</h3>
                                    <p className="mt-3 text-slate-500 group-hover:text-slate-300 transition-colors leading-relaxed">{s[lang].short}</p>
                                    <span className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-cb-accent">
                                        {t.services.more} <ArrowUpRight size={16} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                                    </span>
                                </Link>
                            </Reveal>
                        );
                    })}
                </div>
            </section>
        </>
    );
}
